import { sectionRenderer } from '@theme/section-renderer';
import { RecentlyViewed } from '@theme/recently-viewed-products';

class WifiRecentlyViewed extends HTMLElement {
  async connectedCallback() {
    const productIds = RecentlyViewed.getProducts();
    if (productIds.length === 0) return;

    const sectionId = this.dataset.sectionId;
    if (!sectionId) return;

    const query = productIds.map((id) => `id:${id}`).join(' OR ');
    const url = new URL('/search', window.location.origin);
    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'last');

    let html;
    try {
      html = await sectionRenderer.getSectionHTML(sectionId, false, url);
    } catch {
      return;
    }

    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const newSection = fragment.getElementById(`shopify-section-${sectionId}`);
    const currentSection = document.getElementById(`shopify-section-${sectionId}`);

    if (newSection && currentSection && newSection.textContent?.trim()) {
      currentSection.replaceWith(newSection);
    }
  }
}

if (!customElements.get('wifi-recently-viewed')) {
  customElements.define('wifi-recently-viewed', WifiRecentlyViewed);
}
